export const CLIENT_UTC_OFFSET = -4
export const DATEPART_MONTH = 'month'
export const DATEPART_DAY = 'day'
export const MOMENT_PARSE_FORMAT = ['YYYY/MM/DD HH:mm:ss', 'YYYY/MM/DD HH:mm', 'YYYY/MM/DD']
export const DAY_PER_MONTH = 30
